import { SafeSubscriber } from './subscriber';
import { Subscription } from './subscription';
export class Observable {
  constructor(source) {
    this.source = source;
  }
  subscribe(observer) {
    const subscription = new Subscription();
    const subscriber = new SafeSubscriber(observer, subscription);
    const finalizer = this.source(subscriber);
    if (finalizer) {
      subscription.add(finalizer);
    }
    return subscription;
  }

  // TS is too limited to make it generic - added support for up to 4 operators

  // Implementation that handles all cases
  pipe(...operators) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let intermediate = this;
    for (const operator of operators) {
      intermediate = operator(intermediate);
    }
    return intermediate;
  }
}